const isNil = value => null == value;

export default isNil;
//# sourceMappingURL=isNil.js.map